export const applyTrial = [
    {
        path: '/apply-trial',
        name: 'applyTrial',
        redirect: {
            name: 'selfRegisterLimit',
        },
        component: () => import('@/views/applyTrial/ApplyTrial.vue'),
        children: [
            {
                name: 'selfRegisterLimit',
                path: 'limit',
                component: () => import(/* webpackChunkName: "selefRegister" */ '../../views/applyTrial/Limit/Limit.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.selfRegistionLink',
                        },
                        {
                            text: 'backoffice.nav.systemLimit',
                        },
                        {
                            text: 'backoffice.applyTrial.limit.title',
                            active: true,
                        }
                    ],
                    permission: 'ApplyTrialList',
                },
            }
        ],
    }
];
